import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const EditBranchMaster = createSlice({
  name: "EditBranchMaster",
  initialState: {
    isLoading: false,
    api_completed: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    edit_branch_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_edit_branch_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = true;
      SUCCESE(action.payload.message);
    },
    failure_api_call_edit_branch_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.api_completed = true;
      // FAILED(action.payload);
    },
    edit_branch_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    edit_branch_master_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default EditBranchMaster.reducer;
export const {
  edit_branch_master,
  success_api_call_edit_branch_master,
  edit_branch_master_api_complete,
  edit_branch_isSuccess,
  failure_api_call_edit_branch_master,
} = EditBranchMaster.actions;
